export default "__VITE_ASSET__FyFiddZt__"